module.exports = __webpack_public_path__ + "static/media/mobile-menu.06a02fa5.svg";